export default "<span [ngClass]=\"customCSS\"><ng-content></ng-content></span>";